import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const PDPMobileConfigurationPhotoGallery3dViewer = t0 => {
  const $ = _c(5);
  const {
    hidden,
    children
  } = t0;
  let t1;
  if ($[0] !== hidden) {
    t1 = classNames("h-[100vw] lg:min-h-[750px] [&_.mxt-btn-download]:hidden [&_.mxt-btn-expand]:hidden [&_.mxt-ar-button-short]:hidden", {
      hidden
    });
    $[0] = hidden;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
PDPMobileConfigurationPhotoGallery3dViewer.propTypes = {
  hidden: PropTypes.bool,
  children: PropTypes.node
};
export default PDPMobileConfigurationPhotoGallery3dViewer;